<template>
  <v-main :class="{ 'auth-background': !$vuetify.breakpoint.xs }">
    <v-container
      class="pa-0"
      :class="{ 'elevation-1': !$vuetify.breakpoint.xs }"
      style="max-width:1000px;"
    >
      <v-row>
        <v-col
          style="background: #ffb300"
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
          class="logo"
        >
          <div class="pt-10">
            <logo-sologan></logo-sologan>
          </div>
        </v-col>
        <v-col class="white py-8" xs="12" sm="12" md="7" lg="7" xl="7">
          <div
            align="start"
            class="mx-sm-4 px-sm-4 mx-md-10 px-md-10 py-lg-16 xs-screen"
          >
            <v-form ref="form">
              <div
                class="text-h4 py-5 font-weight-bold" style="color: #ffb300"
              >
                Đặt lại mật khẩu
              </div>
              <subtitle-1>Mật khẩu mới</subtitle-1>
              <br />
              <v-text-field
                label="Mật khẩu"
                v-model="password"
                :type="newPassword ? 'text' : 'password'"
                :append-icon="newPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[$rules.required, $rules.minLength(4), $rules.min]"
                @click:append="newPassword = !newPassword"
                validate-on-blur
                color="amber darken-1"
              />
              <v-text-field
                label="Nhập lại mật khẩu"
                v-model="passwordConfirmation"
                :append-icon="checkPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="checkPassword = !checkPassword"
                :type="checkPassword ? 'text' : 'password'"
                :rules="[
                  $rules.required,
                  $rules.minLength(4),
                  passwordConfirmationRule
                ]"
                color="amber darken-1"
                validate-on-blur
                @keyup.enter="submit"
              />
            </v-form>
            <v-card-actions
              class="d-flex flex-column justify-content-center py-10"
            >
              <v-btn
                color="#FFB300"
                class="px-12 white--text"
                x-large
                @click="submit"
                >Thay đổi</v-btn
              >
            </v-card-actions>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex'
import LogoSologan from '@/modules/image_logo/logo_sologan.vue'

export default {
  components: { LogoSologan },
  data: () => ({
    code: '',
    password: '',
    passwordConfirmation: '',
    newPassword: false,
    checkPassword: false,
    rules: {
      min: v => v.length >= 6 || 'Min 6 characters',
      emailMatch: () => "The email and password you entered don't match"
    }
  }),
  created() {
    this.code = this.$route.query.code
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async submit() {
      if (this.$refs.form.validate()) {
        const { code, password, passwordConfirmation } = this
        await this.resetPassword({ code, password, passwordConfirmation })
      }
    }
  },
  computed: {
    passwordConfirmationRule() {
      return this.password === this.passwordConfirmation || 'Không chính xác'
    }
  }
}
</script>
<style scoped>
.auth-background {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url('../../assets/background.svg') no-repeat center center;
  background-size: cover;
  transform: scale(1);
}
.logo {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media screen and (max-width: 600px) {
  .xs-screen {
    padding: 20px;
  }
}
</style>
